// extracted by mini-css-extract-plugin
export default {"pContent":"Terms_pContent__yHhgp","eventVideo":"Terms_eventVideo__bRLed","pTitle":"Terms_pTitle__a4fuv","pHead":"Terms_pHead__i6jiQ"};